import { useSections } from "@/contexts/classified";
export const useKeySection = () => { var _a, _b; return (_b = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.key) === null || _b === void 0 ? void 0 : _b.keys; };
